import { render, staticRenderFns } from "./TableOfContent.vue?vue&type=template&id=1b59217a&scoped=true"
import script from "./TableOfContent.vue?vue&type=script&lang=js"
export * from "./TableOfContent.vue?vue&type=script&lang=js"
import style0 from "./TableOfContent.vue?vue&type=style&index=0&id=1b59217a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59217a",
  null
  
)

export default component.exports